import { ManifestSection } from '@sap/ux-specification-types';
import type { SAPUI5_FRAGMENT_CLASS, SAPUI5_VIEW_CLASS, Manifest, ViewTypes, v2 } from '@sap/ux-specification-types';
import { syncRule, validity } from '../../../common/decoration/decorators';
import { getObjectPageCustomSectionPath } from '../../application';

export class BaseCustomSection implements v2.ObjectPageCustomSectionBase {
    @syncRule({
        manifest: {
            path: getObjectPageCustomSectionPath,
            export: false,
            import: (
                _manifest: v2.SapUi5ViewExtensionView | v2.SapUi5ViewExtensionFragment,
                sectionId: string
            ): string => {
                const sectionParts = sectionId.split('|');
                return sectionParts[2];
            }
        }
    })
    @validity({
        since: '1.52.0'
    })
    relatedFacet: string;

    @syncRule({
        manifest: {
            path: getObjectPageCustomSectionPath,
            export: false,
            import: (
                _manifest: v2.SapUi5ViewExtensionView | v2.SapUi5ViewExtensionFragment,
                sectionId: string
            ): string => {
                return sectionId.split('|')[0];
            }
        }
    })
    @validity({
        since: '1.52.0'
    })
    relativePosition: v2.SectionPosition;

    @syncRule({
        manifest: {
            path: (entitySet: string[], _manifest: Manifest, sectionId: string): string =>
                getObjectPageCustomSectionPath(entitySet, {} as Manifest, sectionId, ManifestSection.generic)
        }
    })
    @validity({
        since: '1.52.0'
    })
    title: string;

    @syncRule({
        manifest: {
            path: getObjectPageCustomSectionPath
        }
    })
    @validity({
        since: '1.52.0'
    })
    className: typeof SAPUI5_FRAGMENT_CLASS | typeof SAPUI5_VIEW_CLASS;
}

export class ObjectPageCustomSectionFragment extends BaseCustomSection implements v2.ObjectPageCustomSectionFragment {
    declare className: typeof SAPUI5_FRAGMENT_CLASS;

    @syncRule({
        manifest: {
            path: getObjectPageCustomSectionPath
        }
    })
    @validity({
        since: '1.52.0'
    })
    fragmentName: string;

    @syncRule({
        manifest: {
            path: getObjectPageCustomSectionPath
        }
    })
    @validity({
        since: '1.52.0'
    })
    type: v2.ExtensionFragmentTypes;
}

export class ObjectPageCustomSectionView extends BaseCustomSection implements v2.ObjectPageCustomSectionView {
    declare className: typeof SAPUI5_VIEW_CLASS;

    @syncRule({
        manifest: {
            path: getObjectPageCustomSectionPath
        }
    })
    @validity({
        since: '1.52.0'
    })
    viewName: string;

    @syncRule({
        manifest: {
            path: getObjectPageCustomSectionPath
        }
    })
    @validity({
        since: '1.52.0'
    })
    type: ViewTypes;
}
